import { StyleProp, View, ViewStyle } from "react-native";
import Search from "src/components/Search";
import Touchable from "src/components/Touchable";
import IconClose from "src/icons/IconClose";
import { useInsideModal } from "src/modals";
import { paddingLarge } from "src/styles/spacing";
import { useSafeArea } from "src/swsh-native";
import { SearchModalPaddingHorizontal } from "../constants/SearchModalStyleConstants";

const SearchModalHeader = ({
	onSearchChange,
	style,
}: {
	onSearchChange: (text: string) => void;
	style?: StyleProp<ViewStyle>;
}) => {
	const { closeSelf } = useInsideModal();
	const safeArea = useSafeArea();

	return (
		<View
			style={[
				{
					flexDirection: "row",
					paddingHorizontal: SearchModalPaddingHorizontal,
					marginTop: safeArea.top + paddingLarge,
					height: 48,
					width: "100%",
				},
				style,
			]}
		>
			<Search
				autoFocus
				testID="SearchModal-Input"
				onDebouncedChangeText={onSearchChange}
				style={{
					flex: 1,
				}}
			/>
			<Touchable
				onPress={closeSelf}
				containerStyle={{
					alignSelf: "center",
					marginLeft: paddingLarge,
				}}
				hitSlop={20}
			>
				<IconClose size={16} />
			</Touchable>
		</View>
	);
};
export default SearchModalHeader;
